<body class="ltr leftmenu">
    <form autocomplete="off" novalidate [formGroup]="GrievanceLvlForm">
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm">
                        <div class="col-lg-12">
                            <div class="card custom-card">
                                <div class="card-body">
                                    <div class="col-md-8 padding">
                                        <div class=" d-flex align-items-center pl-3">
                                            <img alt="Logo" src="../../assets/img/approval.png" class="mh-45px pb-2">
                                            <div class="">
                                                <h4 class="main-content-label mb-1"><b>
                                                        Grievance Approval
                                                    </b></h4>
                                                <p class="text-muted card-sub-title mb-0">
                                                    Grievance Approval Data
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <hr class="mt-2 mb-2">
                                    <div class="row clearfix mt-3">
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Department </mat-label>
                                                        <mat-select #select5833 class="colorblack" formControlName="DepartmentName">
                                                            <mat-select-filter *ngIf="select5833.focused" [placeholder]="'Filter'"
                                                                [displayMember]="'DepartmentName'" [array]="departmentList"
                                                                (filteredReturn)="filterdepartmentList =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of filterdepartmentList"
                                                                [value]="item.DepartmentID">
                                                                {{item.DepartmentName}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error class="margin_tp aline"
                                                            *ngIf="GrievanceLvlForm.controls['DepartmentName'].touched && GrievanceLvlForm.controls['DepartmentName'].errors?.required">
                                                            Mandatory
                                                        </mat-error>
                
                                                    </mat-form-field>
                                                </div>

                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            Course
                                                        </mat-label>
                                                        <mat-select #select555 class="colorblack"
                                                            formControlName="course" [displayMember]="'CoName'">
                                                            <mat-select-filter *ngIf="select555.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CoName'"
                                                                [array]="CourseList"
                                                                (filteredReturn)="filteredListCourse =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListCourse"
                                                                [value]="item.CoCode" (click)="getClg(item.CoCode)">
                                                                {{item.CoCode}} - {{item.CoName}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error class="margin_tp"
                                                            *ngIf="GrievanceLvlForm.controls['course'].touched && GrievanceLvlForm.controls['course'].errors?.required">
                                                            Mandatory
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>College</mat-label>
                                                        <mat-select #select2333 placeholder="college" class="colorblack"
                                                            formControlName="college">
                                                            <mat-select-filter *ngIf="select2333.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CgName'"
                                                                [array]="collegeList"
                                                                (filteredReturn)="filteredCollegeList =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredCollegeList"
                                                                [value]="item.CgCode" (click)="getAssign(item)">
                                                                {{item.CgCode}} - {{item.CgName}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error class="margin_tp"
                                                        *ngIf="GrievanceLvlForm.controls['college'].touched && GrievanceLvlForm.controls['college'].errors?.required">
                                                        Mandatory
                                                    </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div  *ngIf="Table" class="table-responsive mt-4">
                                            <div class="container">
                                                <table id="datatable" class="table table-bordered">
                                                    <thead>
                                                        <tr class="">
                                                            <th class="f600  text-left" width="35%">
                                                                User
                                                            </th>
                                                            <th class="f600  text-left" width="30%">
                                                                Role
                                                            </th>
                                                            <th class="f600  text-center" width="10%">
                                                                Level
                                                            </th>
                                                           
                                                            <th class="f600 text-center" width="20%">
                                                                Action
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody id="table_data" formArrayName="LvlArray">
                                                        <tr *ngFor="let sem of getLvlArrayControls(); let i = index; let last = last "
                                                        [formGroupName]="i">
                                                        <td>
                                                            <mat-form-field appearance="outline"
                                                                class="example-full-width">
                                                                <mat-label>
                                                                    User
                                                                </mat-label>
                                                                <mat-select #select5444 class="color"
                                                                    formControlName="UserId">
                                                                    <mat-select-filter *ngIf="select5444.focused"
                                                                        [placeholder]="'Filter'"
                                                                        [displayMember]="'LoginFullName'"
                                                                        [array]="userList"
                                                                        (filteredReturn)="filteredUserList =$event">
                                                                    </mat-select-filter>
                                                                    <mat-option
                                                                    *ngFor="let item of filteredUserList"
                                                                        [value]="item.LoginId"
                                                                        (click)="UserData(item.LoginId, i)"
                                                                        [disabled]="isOptionDisabled(item.LoginId,i)">
                                                                        {{item.LoginId}} - {{item.LoginFullName}}
                                                                    </mat-option>
                                                                </mat-select>
                                                                <mat-error class="margin_tp mrgtp"
                                                                        *ngIf="sem.controls.UserId.touched && sem.controls.UserId.errors?.required">
                                                                        Mandatory
                                                                    </mat-error>
                                                            </mat-form-field>
                                                        </td>
                                                        <td>
                                                            <mat-form-field appearance="outline"
                                                                class="example-full-width">
                                                                <mat-label>
                                                                    Role
                                                                </mat-label>
                                                                <mat-select #select5333 class="color"
                                                                    formControlName="Role">
                                                                    <mat-select-filter *ngIf="select5333.focused"
                                                                        [placeholder]="'Filter'"
                                                                        [displayMember]="'CdDesc'"
                                                                        [array]="RoleList"
                                                                        (filteredReturn)="filteredRoleList =$event">
                                                                    </mat-select-filter>
                                                                    <mat-option 
                                                                        *ngFor="let item of filteredRoleList"
                                                                        [value]="item.CdCode">
                                                                        {{item.CdCode}} - {{item.CdDesc}}
                                                                    </mat-option>
                                                                </mat-select>
                                                                <mat-error class="margin_tp mrgtp"
                                                                        *ngIf="sem.controls.Role.touched && sem.controls.Role.errors?.required">
                                                                        Mandatory
                                                                    </mat-error>
                                                            </mat-form-field>
                                                        </td>

                                                        <td class="text-center">
                                                            <input readonly class="form-control text-center"
                                                                formControlName="AssignLevel" maxlength="5">
                                                        </td>
                                                 
                                                        <td class="text-center">
                                                            <a *ngIf="last" class="btn-floating" title="AddNew">
                                                                <i class="fa fa-plus"
                                                                    (click)="addNewRow2();"></i>
                                                            </a>
                                                            <a *ngIf="last" class="btn-floating" title="Remove">
                                                                <i class="fa fa-minus"
                                                                    (click)="deleteRow(i)"></i></a>

                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                        </div>

                                        <div class="row">
                                            <div class="col-sm-9"></div>
                                            <div class="col-sm-3 pri-0" >
                                                <button type="button"
                                                    class="btn btn-primary btn-icon-text floatright mt-1"  (click)="submit()">
                                                    <!-- (click)="submit()" -->
                                                    <span style="display: contents; align-items: center;">
                                                        <img width="20rem" src="../../assets/img/save.gif"
                                                            style="margin-right: 5px;">
                                                        Save
                                                    </span>
                                                </button>
                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </form>
</body>